import { render, staticRenderFns } from "./MessageBar.vue?vue&type=template&id=f60f5d26&"
import script from "./MessageBar.vue?vue&type=script&lang=js&"
export * from "./MessageBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessageBar.vue"
export default component.exports